import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideMsDesignSystem } from '@Mobilesentrix/ms-design-system';
import { provideApollo } from 'apollo-angular';
import { routes } from './app.routes';
import { apolloOptionsFactory } from './core/graphql/apollo.config';
import { authInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideMsDesignSystem(),
    provideApollo(apolloOptionsFactory),
  ],
};
